import { useCookie } from "#imports";

export function useAuthRedirect() {
  const cookieName = `oo:auth-redirect`;
  const cookie = useCookie<string | undefined>(cookieName, undefined);

  const persist = (route: string) => {
    cookie.value = route;
  };

  const reset = () => {
    cookie.value = undefined;
  };

  const retrieve = () => {
    const storedRoute = cookie.value;

    if (storedRoute) {
      reset();
    }

    return storedRoute;
  };

  return {
    cookieName,
    persist,
    retrieve,
    reset,
  };
}
